import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/no-picture.png';
const _hoisted_1 = {
  class: "programm-list-page"
};
const _hoisted_2 = {
  class: "wrap white-bg"
};
const _hoisted_3 = {
  class: "text-large font-600 mr-3"
};
const _hoisted_4 = {
  class: "content-wrap"
};
const _hoisted_5 = {
  class: "content-wrap-left"
};
const _hoisted_6 = {
  class: "selected-program-item-form"
};
const _hoisted_7 = {
  class: "selected-program-item-form-footer"
};
const _hoisted_8 = {
  class: "selected-program-item"
};
const _hoisted_9 = {
  class: "selected-program-item-list"
};
const _hoisted_10 = {
  class: "content-wrap-right"
};
import { getToken } from '@/api';
import CheckNewLiveList from './components/CheckNewLiveList.vue';
import { ref, onMounted, reactive, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getAppLiveProgramPage, addLiveRoom, getAppLiveRoom, updateLiveRoom } from '@/request/program';
import { getAppInteractiveList } from '@/request/index';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { getAppUserKnowledgePage } from '@/request/knowledge';
import { queryProject } from '@/request';

// ref

export default {
  __name: 'newlive',
  setup(__props) {
    const checkNewLiveDialog = ref(null);
    const uploader = ref(); // 上传组件
    const formEL = ref(); // 表单
    let CheckNewLiveListRef = ref(null);
    const baseApi = process.env.VUE_APP_API_BASE_URL; // 基础API
    const headers = {
      Authorization: getToken()
    }; // 请求头

    // 参数
    const uploadLoading = ref(false); // 上传loading
    const selectedPrograms = ref([]); //选中的节目列表
    const router = useRouter(); //路由
    const route = useRoute(); //路由
    const pageType = route.params.type; //页面类型
    const knowladgeVisible = ref(false); //知识库弹窗
    const currentId = ref(null); //当前直播间id 如果有id 则为编辑
    const uploadedFileInfo = ref([]); // 上传文件信息
    const interactiveList = ref([]); // 数字人列表
    let screenDic = [{
      label: '横屏',
      value: '横屏'
    }, {
      label: '竖屏',
      value: '竖屏'
    }];
    const infoForm = reactive({
      name: '',
      industryId: 0,
      industryType: '',
      knowledgeIds: [],
      liveDuration: 0,
      liveProgramIds: [],
      showUrl: '',
      screen: '横屏',
      InteractiveId: ''
    }); // 表单
    const rules = ref({
      name: [{
        required: true,
        message: '请输入名称',
        trigger: 'blur'
      }],
      industryType: [{
        required: true,
        message: '请选择行业类型',
        trigger: 'blur'
      }],
      screen: [{
        required: true,
        message: '请选择直播屏幕类型',
        trigger: 'blur'
      }],
      InteractiveId: [{
        required: true,
        message: '请选择数字人',
        trigger: 'change'
      }]
    }); // 表单验证

    onMounted(async () => {
      currentId.value = route.query.id;
      if (currentId.value) {
        await getLiveRoomById(currentId.value);
      }
      await getAppInteractives();
    });

    // 屏幕类型
    let changeRadio = async screen => {
      await getAppInteractives();
      infoForm.InteractiveId = '';
      let refs = CheckNewLiveListRef.value;
      refs.handleCreated({
        screen
      });
    };

    // 获取数字人列表
    const getAppInteractives = async () => {
      try {
        const res = await getAppInteractiveList({
          screen: infoForm.screen
        });
        const {
          data
        } = res.data;
        interactiveList.value = data;
        console.log(interactiveList.value, 'interactiveList', res.data);
      } catch (error) {
        console.error(error);
      }
    };

    // 获取直播间详情
    const getLiveRoomById = async id => {
      const res = await getAppLiveRoom(id);
      const {
        data
      } = res.data;
      console.log('data', data);
      infoForm.screen = data.screen;
      infoForm.name = data.name;
      infoForm.industryId = data.industryId;
      infoForm.industryType = data.industryType;
      infoForm.knowledgeIds = data.knowledgeIds;
      infoForm.liveDuration = data.liveDuration;
      infoForm.showUrl = data.showUrl;
      infoForm.InteractiveId = data.interactiveId;
      infoForm.screen = data.screen;
      uploadedFileInfo.value = data.showUrl ? [{
        url: data.showUrl,
        name: extractImageName(data.showUrl)
      }] : [];
      data.livePrograms.forEach(item => {
        handleChecked(item);
      });
    };

    // 提取图片名称
    function extractImageName(url) {
      const lastSlashIndex = url.lastIndexOf('/'); // 找到最后一个斜杠的位置
      const imageName = url.substring(lastSlashIndex + 1); // 从最后一个斜杠后面的字符开始截取到字符串末尾
      return imageName;
    }

    // 时间格式化
    const formatDate = dateString => {
      const date = new Date(dateString);
      const year = date.getFullYear().toString().slice(-2); // 获取最后两位年份
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，加1并确保两位数
      const day = date.getDate().toString().padStart(2, '0'); // 日期确保两位数
      return `${year}-${month}-${day}`; // 格式为 'yy-mm-dd'
    };

    // 删除节目
    const handleDelete = (index, row) => {
      // 通过id删除
      // selectedPrograms.value = selectedPrograms.value.filter((item) => item.id !== row.id);
      // 通过id删除
      nextTick(() => {
        const idx = selectedPrograms.value.findIndex(item => item.id === row.id);
        if (idx !== -1) {
          selectedPrograms.value.splice(idx, 1);
        }
      });
    };

    // 处理选中
    const handleChecked = val => {
      const index = selectedPrograms.value.findIndex(item => item.id === val.id);
      if (index !== -1) {
        // 如果找到了，从数组中移除
        selectedPrograms.value.splice(index, 1);
      } else {
        // 如果没有找到，添加到数组中
        selectedPrograms.value.push(val);
      }
    };

    // 上传成功
    const handleSuccess = res => {
      console.log(res, '上传成功');
      uploadLoading.value = false;
      const {
        filename,
        url
      } = res.data;
      infoForm.showUrl = url;
      console.log(infoForm, 'form');
    };

    // 上传图片验证
    const handleBeforeUpload = rawFile => {
      if (!rawFile.type.includes('png') && !rawFile.type.includes('jpg') && !rawFile.type.includes('jpeg')) {
        ElMessage.error('仅支持上传png、jpg图片!');
        return false;
      }
      if (rawFile.size > 5 * 1024 * 1024) {
        ElMessage.error('上传图片大小不能超过5M！');
        return false;
      }
      uploadLoading.value = true;
      return true;
    };

    // 格式化秒数为时间
    const formatSecondsToTime = seconds => {
      let milliseconds = seconds * 1000; // 转换为毫秒
      let hours = Math.floor(milliseconds / (1000 * 60 * 60));
      let minutes = Math.floor(milliseconds % (1000 * 60 * 60) / (1000 * 60));
      let remainingSeconds = Math.floor(milliseconds % (1000 * 60) / 1000);
      let millisecondsRemainder = milliseconds % 1000;

      // 确保小时、分钟、秒和毫秒始终显示两位数（对于小时，可能需要显示一位或两位）
      hours = String(hours).padStart(2, '0');
      minutes = String(minutes).padStart(2, '0');
      remainingSeconds = String(remainingSeconds).padStart(2, '0');
      millisecondsRemainder = String(millisecondsRemainder).substring(0, 3).padStart(3, '0');
      return `${hours}:${minutes}:${remainingSeconds}.${millisecondsRemainder}`;
    };
    const durationValidator = (rule, value, callback) => {
      if (value < 15) {
        callback(new Error('节目总时长过短，建议不低于15分钟'));
      } else {
        callback();
      }
    };
    const onSubmit = fromEl => {
      if (!formEL) return;
      fromEl.validate(valid => {
        if (valid) {
          currentId.value ? onEdit() : onAdd();
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    };
    const onEdit = async () => {
      if (selectedPrograms.value.length == 0) {
        ElMessage.error('请选择节目');
        return;
      }
      const liveProgramIds = selectedPrograms.value.map(item => item.id);
      const res = await updateLiveRoom({
        id: currentId.value,
        name: infoForm.name,
        showUrl: infoForm.showUrl,
        industryType: infoForm.industryType,
        knowledgeIds: infoForm.knowledgeIds,
        liveDuration: infoForm.liveDuration || 0,
        liveProgramIds,
        interactiveId: infoForm.InteractiveId,
        liveType: pageType == 1 ? 2 : 1,
        screen: infoForm.screen
      });
      if (res.data.code == 200) {
        ElMessage.success('编辑成功');
        router.go(-1);
      }
    };
    const onAdd = async () => {
      if (selectedPrograms.value.length == 0) {
        ElMessage.error('请选择节目');
        return;
      }
      const liveProgramIds = selectedPrograms.value.map(item => item.id);
      console.log(selectedPrograms.value[0], infoForm);
      const res = await addLiveRoom({
        name: infoForm.name,
        // "industryId": 0,
        showUrl: infoForm.showUrl,
        industryType: infoForm.industryType,
        knowledgeIds: infoForm.knowledgeIds,
        liveDuration: infoForm.liveDuration || 0,
        liveProgramIds,
        interactiveId: infoForm.InteractiveId,
        // interactivePlatformId: selectedPrograms.value[0].platformId,
        // interactivePlatformKey: selectedPrograms.value[0].virtualManKey,
        liveType: pageType == 1 ? 2 : 1,
        screen: infoForm.screen
      });
      if (res.data.code == 200) {
        ElMessage.success('添加成功');
        router.go(-1);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_page_header = _resolveComponent("el-page-header");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_page_header, {
        class: "top-wrap",
        onBack: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, {
        content: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString(currentId.value ? '编辑直播间' : '创建直播间'), 1)]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "selected-program-item-title"
      }, [_createElementVNode("span", {
        class: "text-large"
      }, "直播间信息")], -1)), _createVNode(_component_el_form, {
        "label-position": "left",
        class: "selected-program-item-form-content",
        "label-width": "auto",
        model: infoForm,
        style: {
          "width": "100%"
        },
        rules: rules.value,
        ref_key: "formEL",
        ref: formEL
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "屏幕类型",
          prop: "screen"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: infoForm.screen,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => infoForm.screen = $event),
            onChange: _unref(changeRadio)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(screenDic), i => {
              return _openBlock(), _createBlock(_component_el_radio, {
                value: i.value
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(i.label), 1)]),
                _: 2
              }, 1032, ["value"]);
            }), 256))]),
            _: 1
          }, 8, ["modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "选择数字人",
          prop: "InteractiveId"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: infoForm.InteractiveId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => infoForm.InteractiveId = $event),
            placeholder: "选择数字人"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interactiveList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "直播间名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: infoForm.name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => infoForm.name = $event),
            "aria-placeholder": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "行业类型",
          prop: "industryType"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: infoForm.industryType,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => infoForm.industryType = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "背景图",
          prop: "showUrl"
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_upload, {
            class: "uploader",
            ref_key: "uploader",
            ref: uploader,
            action: `${_unref(baseApi)}/common/upload`,
            accept: "jpg,jpeg,png",
            headers: headers,
            limit: 1,
            "before-upload": handleBeforeUpload,
            "on-success": handleSuccess,
            "file-list": uploadedFileInfo.value
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("上传背景图")])),
              _: 1
            })]),
            _: 1
          }, 8, ["action", "file-list"])), [[_directive_loading, uploadLoading.value]])]),
          _: 1
        }), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = $event => onSubmit(formEL.value))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(currentId.value ? '保存直播间' : '创建直播间'), 1)]),
          _: 1
        })])]),
        _: 1
      }, 8, ["model", "rules"])]), _createElementVNode("div", _hoisted_8, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "selected-program-item-title"
      }, [_createElementVNode("span", {
        class: "text-large"
      }, "已选节目")], -1)), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_table, {
        size: "mini",
        data: selectedPrograms.value,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "backgroundUrl",
          label: "背景"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_image, {
            src: scope.row.backgroundUrl || undefined,
            style: {
              "width": "50px",
              "height": "50px",
              "z-index": "100"
            }
          }, {
            error: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("div", {
              class: "image-slot"
            }, [_createElementVNode("img", {
              src: _imports_0,
              style: {
                "width": "50px",
                "height": "50px"
              }
            })], -1)])),
            _: 2
          }, 1032, ["src"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "节目名称",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.createTime ? formatDate(scope.row.createTime) : ''), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            size: "small",
            type: "danger",
            onClick: $event => handleDelete(scope.$index, scope.row)
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" 取消选中 ")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])])]), _createElementVNode("div", _hoisted_10, [_createVNode(CheckNewLiveList, {
        ref_key: "CheckNewLiveListRef",
        ref: CheckNewLiveListRef,
        selectedPrograms: selectedPrograms.value,
        onChecked: handleChecked
      }, null, 8, ["selectedPrograms"])])])])), [[_directive_loading, _ctx.loading]])]);
    };
  }
};